var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 15.669C12.9642 16.9943 10.972 17.7944 8.79508 17.7944C3.93769 17.7944 0 13.811 0 8.89718C0 3.9834 3.93769 0 8.79508 0C10.972 0 12.9642 0.800077 14.5 2.12541C16.0358 0.800077 18.028 0 20.2049 0C25.0623 0 29 3.9834 29 8.89718C29 13.811 25.0623 17.7944 20.2049 17.7944C18.028 17.7944 16.0358 16.9943 14.5 15.669Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 15.669C16.3911 14.037 17.5902 11.6088 17.5902 8.89718C17.5902 6.18559 16.3911 3.75732 14.5 2.12541C16.0358 0.800077 18.028 0 20.2049 0C25.0623 0 29 3.9834 29 8.89718C29 13.811 25.0623 17.7944 20.2049 17.7944C18.028 17.7944 16.0358 16.9943 14.5 15.669Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 15.669C16.3911 14.0371 17.5902 11.6088 17.5902 8.89722C17.5902 6.18565 16.3911 3.7574 14.5 2.12549C12.609 3.7574 11.4099 6.18565 11.4099 8.89722C11.4099 11.6088 12.609 14.0371 14.5 15.669Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.cca88c3b688092253bcd4b759e3643aa.svg";
export { ForwardRef as ReactComponent };